<template>
  <div v-bind="$attrs">
    <label>
      {{ label }}
      <v-textarea
        ref="so-textarea"
        v-model="value"
        :rules="rules"
        :readonly="readonly"
        :error="!!error"
        :error-messages="error ? [error] : undefined"
        :bg-color="readonly ? 'background' : 'surface'"
        :validate-on="isValidInternal || isPristineInternal ? 'blur' : 'input'"
        :maxlength="maxLength"
        :counter="counter"
        :placeholder="placeholder"
        :disabled="disabled"
        :rows="rows"
        hide-details="auto"
        variant="solo"
        color="success"
        density="comfortable"
        class="mb-1"
      >
        <template #append="{ isValid, isPristine }">
          {{ assignToData(isValid.value, isPristine.value) }}
        </template>
      </v-textarea>
    </label>
  </div>
</template>

<script lang="ts">
  import { ValidationRule } from "@/types/ValidationRule"
  import { defineComponent, PropType } from "vue"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      modelValue: {
        type: String as PropType<string | null>,
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      rows: {
        type: [String, Number],
        default: 3,
      },
      error: {
        type: String,
        default: null,
      },
      rules: {
        type: Array as PropType<ValidationRule[]>,
        default: [] as ValidationRule[],
      },
      maxLength: {
        type: Number,
        default: undefined,
      },
      counter: {
        type: Boolean as PropType<true | undefined>,
        default: undefined,
      },
      placeholder: {
        type: String,
        default: undefined,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        isValidInternal: null as null | boolean,
        isPristineInternal: null as null | boolean,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(val: string) {
          this.$emit("update:modelValue", val)
        },
      },
    },
    methods: {
      assignToData(isValid: boolean | null, isPristine: boolean | null) {
        this.isValidInternal = isValid
        this.isPristineInternal = isPristine
      },
    },
  })
</script>

<style scoped>
  :deep(.v-input__append) {
    display: none;
  }
  :deep(.v-field) {
    border-radius: var(--theme-radius);
    transition: border 250ms;
  }
  :deep(.v-field:hover) {
    border: 1px solid rgb(var(--v-theme-on-surface));
  }
  :deep(.v-field--focused) {
    outline: var(--theme-outline);
  }
  :deep(.v-field--error) {
    border: 1px solid rgb(var(--v-theme-error)) !important;
  }
  :deep(.v-field--variant-solo) {
    box-shadow: none !important;
    border: 1px solid rgb(var(--v-theme-border));
  }
</style>
